// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"dbc4f2f3","239":"a2d85800","453":"ca7e61f3","455":"1f915666"}[chunkId] + ".chunk.js";
};